<div class="input-wrapper d-inline-block">
	<div class="form-check d-inline-block m-0">
		<input type="checkbox" class="form-check-input" [id]="id" [formControl]="control"
			[ngClass]="{invalid: control.touched && control.errors}">
		<label [for]="id" class="form-check-label" [class.no-label]="!label">
			{{label}}
		</label>
	</div>
</div>